"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iframeFix = void 0;
// eslint-disable-next-line prettier/prettier
function iframeFix() {
    var doc = document;
    var isEmbedded = window.parent !== window;
    var cpControls = isEmbedded && document.querySelector("rm-canvas-player-controls");
    var logPrefix = "[rm-personalized-video".concat(cpControls ? "(child)" : "(parent)", "]");
    var otherOrigin = "*"; // Changed with init event;
    var forceOverride = true;
    var pendingFullscreenElement = null;
    var savedScrollPosition = 0;
    function log() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // eslint-disable-next-line no-console
        console.log.apply(console, __spreadArray([logPrefix], args, false));
    }
    function setupFakeFullscreen() {
        if (!cpControls) {
            throw new Error("Should not get here!");
        }
        var isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
        var fullScreenEnabled = doc.fullscreenEnabled || doc.mozFullScreenEnabled || doc.webkitFullscreenEnabled || doc.msFullscreenEnabled;
        var shouldPatch = forceOverride || (isIos && !fullScreenEnabled);
        if (!shouldPatch)
            return;
        Element.prototype.requestFullscreen = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    pendingFullscreenElement = this;
                    window.parent.postMessage({
                        type: "rm-personalized-video-request-fullscreen",
                    }, otherOrigin);
                    return [2 /*return*/];
                });
            });
        };
        doc.exitFullscreen = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    window.parent.postMessage({
                        type: "rm-personalized-video-exit-fullscreen",
                    }, otherOrigin);
                    return [2 /*return*/];
                });
            });
        };
        Object.defineProperty(document, "fullscreenElement", {
            value: null,
            writable: true,
        });
        Object.defineProperty(document, "fullscreenEnabled", {
            value: true,
            writable: false,
        });
        cpControls.fullScreenSupported = cpControls.isFullscreenSupported();
        cpControls.fullScreenBtn.classList.remove("hide");
    }
    window.addEventListener("message", function (event) {
        if (event.data && typeof event.data.type === "string" && event.data.type.startsWith("rm-personalized-video")) {
            var data = event.data;
            var iframe = Array.from(document.getElementsByTagName("iframe")).filter(function (el) { return el.contentWindow === event.source; })[0];
            switch (data.type) {
                // PARENT
                case "rm-personalized-video-init":
                    {
                        otherOrigin = data.origin;
                        iframe.style.aspectRatio = data.aspectRatio;
                        iframe.style.height = "auto";
                        iframe.contentWindow.postMessage({
                            type: "rm-personalized-video-ack",
                            origin: window.location.origin,
                        }, otherOrigin);
                    }
                    break;
                case "rm-personalized-video-request-fullscreen": {
                    var scrollingElement = document.scrollingElement;
                    savedScrollPosition = scrollingElement.scrollTop;
                    iframe.style.position = "fixed";
                    iframe.style.top = "0";
                    iframe.style.left = "0";
                    iframe.style.width = "100vw";
                    iframe.style.height = "100vh";
                    iframe.style.zIndex = "99999";
                    // scrollingElement.style.height = "100vh";
                    // scrollingElement.style.overflow = "hidden";
                    iframe.contentWindow.postMessage({
                        type: "rm-personalized-video-request-fullscreen-ack",
                    }, otherOrigin);
                    break;
                }
                case "rm-personalized-video-exit-fullscreen": {
                    iframe.style.position = "";
                    iframe.style.top = "";
                    iframe.style.left = "";
                    iframe.style.width = "";
                    iframe.style.height = "auto";
                    iframe.style.zIndex = "";
                    var scrollingElement = document.scrollingElement;
                    // scrollingElement.style.height = "";
                    // scrollingElement.style.overflow = "";
                    scrollingElement.scrollTop = savedScrollPosition;
                    iframe.contentWindow.postMessage({
                        type: "rm-personalized-video-exit-fullscreen-ack",
                    }, otherOrigin);
                    break;
                }
                //CHILD
                case "rm-personalized-video-ack": {
                    otherOrigin = data.origin;
                    if (cpControls)
                        cpControls.player.handleResizeDebounced();
                    setupFakeFullscreen();
                    break;
                }
                case "rm-personalized-video-request-fullscreen-ack": {
                    doc.fullscreenElement = pendingFullscreenElement;
                    pendingFullscreenElement = null;
                    var event_1 = new Event("fullscreenchange");
                    document.dispatchEvent(event_1);
                    break;
                }
                case "rm-personalized-video-exit-fullscreen-ack": {
                    document.fullscreenElement = null;
                    var event_2 = new Event("fullscreenchange");
                    document.dispatchEvent(event_2);
                    break;
                }
                default:
                    log("UNKNOWN MESSAGE TYPE:", data);
            }
        }
    });
    function initFromChild(e) {
        if (document.readyState !== "complete")
            return;
        if (e) {
            try {
                document.removeEventListener("readystatechange", initFromChild);
            }
            catch (e) {
                // Do nothing;
            }
        }
        if (cpControls) {
            // Embedded in iframe. Try to contact parent
            window.parent.postMessage({
                type: "rm-personalized-video-init",
                aspectRatio: "".concat(cpControls.player.width, " / ").concat(cpControls.player.height),
                origin: window.location.origin,
            }, otherOrigin);
        }
    }
    if (cpControls) {
        if (document.readyState === "complete") {
            initFromChild();
        }
        else {
            document.addEventListener("readystatechange", initFromChild);
        }
    }
}
exports.iframeFix = iframeFix;
//# sourceMappingURL=iframe-fix.js.map
//# sourceMappingURL=module.js.map